<app-menu [hasChanges]="loadMenu"></app-menu>
<app-loading [show]="load"></app-loading>

<div class="p-fluid p-2">
    <div>
        <h2 class="uppercase">Definición de rangos</h2>
    </div>
    <!--Diseño Selección de variable-->
    <section>
        <div class="w-full flex flex-column">
            <label for="">Seleccione el tipo de variable</label>
            <p-dropdown [options]="lsArrayVars" [(ngModel)]="lsVarsSelected" optionLabel="strData" class="w-full"
                placeholder="Seleccione una variable" (onChange)="getRangos()" />
            <span class="text-xs">{{lsVarsSelected.observacion}}</span>
        </div>
    </section>
    <!--Recorrido y creación de rangos-->
    <section *ngIf="!!lsRangos">
        <h5 class="uppercase">Rangos creados</h5>
        <div class="w-full flex flex-wrap mt-2" *ngFor="let item of lsRangos">
            <div class="w-full md:w-5 p-1">
                <label for="">Descripción del Rango</label>
                <input type="text" [(ngModel)]="item.descripcion" pInputText
                    placeholder="Relacione la descripción del rango">
            </div>
            <div class="w-6 md:w-3 p-1">
                <label for="">Rango Inicial</label>
                <p-inputNumber inputId="integeronly" [(ngModel)]="item.rangoInicial" />
            </div>
            <div class="w-5 md:w-3 p-1">
                <label for="">Rango Final</label>
                <p-inputNumber inputId="integeronly" [(ngModel)]="item.rangoFinal" />
            </div>
            <div class="w-1 p-1 flex flex-column-reverse">
                <button pButton class="p-button p-button-success" icon="pi pi-check-circle"
                    (click)="setRango(item)"></button>
            </div>

            <div class="w-full"><span [innerHTML]="item.message"></span></div>
        </div>
        <div class="w-full text-center mt-2">
            <button pButton class="p-button p-button-success w-auto" label="Adicionar Rango" icon="pi pi-plus-circle"
                (click)="add()"></button>
        </div>
    </section>
</div>
<p-toast></p-toast>